import ServiceCenterChangeHistory from 'app/Apps/ContainerManagement/ServiceCenters/ServiceCenterChangeHistory'
import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab,
} from 'app/shared-components/SkyNetDomain'
import useHasPermission from 'app/hooks/useHasPermission'
import useTabsByPermission from 'app/hooks/useTabsByPermission'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    ServiceCenterStatus,
} from 'app/enums/label.enums'
import {
    ServiceCenterTabs,
} from 'app/enums/domain.enums'
import request from 'app/requests/ServiceCenter/ServiceCenter.requests'
import useLabel from 'app/hooks/useLabel'

import tableConfig from './serviceCenters.config'
import ServiceCenterCreate from './ServiceCenterCreate'
import ServiceCenterOverview from './ServiceCenterOverview'
import ServiceCenterUpdate from './ServiceCenterUpdate'
import Monitoring from './Monitoring'
import ScenarioEditor from './ScenarioEditor'
import RelatedOrders from './RelatedOrders'
import WorkSchedule from './WorkSchedule'
import PoolingDataUpdate from './PoolingDataUpdate'
import DailyOpsDataUpdate from './DailyOpsDataUpdate'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ShowArhived,
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const isSCActive = ({
    serviceCenterStatus,
    archived,
}) => {
    return serviceCenterStatus === ServiceCenterStatus.ACTIVE && !archived
}

const isNotArchived = ({
    archived,
}: { archived: boolean }) => {
    return !archived
}

const ServiceCenters = () => {
    const canCreate = useHasPermission(['service_center_create'])
    const canUpdate = useHasPermission(['service_center_update'])
    const canUpdateProcurement = useHasPermission(['service_center_update_procurement'])
    const canUpdatePooling = useHasPermission(['service_center_update_pooling'])
    const canUpdateDaily = useHasPermission(['service_center_update_daily'])
    const canMonitoring = useHasPermission(['service_center_monitoring'])

    const l = useLabel()

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                url: CommonRoutes.Overview,
                label: l('OVERVIEW'),
                Component: ServiceCenterOverview,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.DataUpdate,
                label: l('PROCUREMENT_DATA_UPDATE'),
                Component: ServiceCenterUpdate,
            },
            permission: canUpdateProcurement,
        },
        {
            tab: {
                url: ServiceCenterTabs.PoolingDataUpdate,
                label: l('POOLING_DATA_UPDATE'),
                Component: PoolingDataUpdate,
            },
            permission: canUpdatePooling,
        },
        {
            tab: {
                url: ServiceCenterTabs.DailyOpsDataUpdate,
                label: l('DAILY_OPS_DATA_UPDATE'),
                Component: DailyOpsDataUpdate,
            },
            permission: canUpdateDaily,
        },
        {
            tab: {
                url: ServiceCenterTabs.Monitoring,
                label: l('MONITORING'),
                Component: Monitoring,
                condition: isSCActive,
            },
            permission: canMonitoring,
        },
        {
            tab: {
                url: ServiceCenterTabs.ScenarioEditor,
                label: 'Scenario Editor',
                Component: ScenarioEditor,
                condition: isSCActive,
            },
            permission: canMonitoring,
        },
        {
            tab: {
                url: ServiceCenterTabs.WorkSchedule,
                label: l('WORK_SCHEDULE'),
                Component: WorkSchedule,
            },
            permission: canUpdate,
        },
        {
            tab: {
                url: ServiceCenterTabs.RelatedOrders,
                label: l('RELATED_ORDERS'),
                Component: RelatedOrders,
                condition: isNotArchived,
            },
            permission: true,
        },
        {
            tab: {
                url: CommonRoutes.ChangeHistory,
                label: l('CHANGE_HISTORY'),
                Component: ServiceCenterChangeHistory,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            defaultTab={CommonRoutes.Overview}
            name={tableConfig.name}
            getDomainObject={request.get}
            actionComponents={{
                Create: canCreate ? ServiceCenterCreate : undefined,
            }}
            sidebarTabs={tabs}
            domainRequestKey={RequestKeys.getServiceCenterById}
        >
            <SkyNetTable
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default ServiceCenters
